import axios from "axios";

import type {
  IGetLenderCompanyParams,
  IGetLenderCompanyResponse,
  ILenderCompany,
  IUpdateLenderCompanyInput,
} from "./types";

export const getMyLenderCompanies = async (params: IGetLenderCompanyParams) => {
  const response = await axios.get<IGetLenderCompanyResponse>(
    "/lender/api/v2/me/lender-companies",
    {
      params,
    },
  );

  return response.data;
};

export const getLenderCompany = async (lenderCompanyId: number) => {
  const response = await axios.get<ILenderCompany>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}`,
  );

  return response.data;
};

export const updateLenderCompany = async (
  lenderCompanyId: number,
  data: IUpdateLenderCompanyInput,
) => {
  const response = await axios.patch<ILenderCompany>(
    `/lender/api/v2/lender-companies/${lenderCompanyId}`,
    data,
  );

  return response.data;
};
